import { Drawer } from "antd";
import Paragraph from "antd/lib/typography/Paragraph";
import CTable from "components/CTable";

const DeviceInfo = ({ data = [], visible, onClose }) => {
  const columns = [
    {
      title: "S.n.",
      dataIndex: "sn",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Device serial no.",
      dataIndex: "serialNo",
      render: (text) => <Paragraph copyable>{text}</Paragraph>,
    },
    {
      title: "Model no.",
      dataIndex: "modelNo",
    },
  ];
  return (
    <Drawer title="Devices" visible={visible} onClose={onClose}>
      <CTable columns={columns} dataSource={data}></CTable>
    </Drawer>
  );
};
export default DeviceInfo;
